.container {
  margin: 0 auto;
  padding: 1.875rem 1.5rem;
  position: relative;
}